import { render, staticRenderFns } from "./PeriodosConsumo.vue?vue&type=template&id=d3257df2&"
import script from "./PeriodosConsumo.vue?vue&type=script&lang=js&"
export * from "./PeriodosConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports